require('videogular');
require('./vg-overlay-play');

module.exports = 'com.2fdevs.videogular.plugins.overlayplay';



//////////////////
// WEBPACK FOOTER
// ./~/videogular-overlay-play/index.js
// module id = ./node_modules/videogular-overlay-play/index.js
// module chunks = 1